function appStateReducer(state) {
  return state
}

export default appStateReducer
